const splitList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

const TALENT_TYPE_OPTIONS = [
  "Graphic Designer",
  "Web Developer",
  "Mobile App",
  "Marketing Specialist",
  "Copywriter",
  "Data Analyst",
  "Video Editor",
  "UI/UX Designer",
  "Other",
];

const COMMUNICATION_TOOL_OPTIONS = [
  "Slack",
  "Microsoft Teams",
  "Zoom",
  "Google Meet",
  "Other",
];

const getKnownAndOther = (values = [], options = [], explicitOther = "") => {
  const uniqueValues = [...new Set(values.filter(Boolean))];
  const knownSet = new Set(options);

  const known = uniqueValues.filter((item) => knownSet.has(item) && item !== "Other");
  const inferredOther = uniqueValues.filter((item) => !knownSet.has(item));
  const otherValue = explicitOther || inferredOther.join(", ");

  const selected = otherValue ? [...known, "Other"] : known;
  return {
    selected,
    other: otherValue,
  };
};

export const normalizeHireTalentProfile = (raw = {}) => {
  const data = raw || {};
  const firstProject =
    (Array.isArray(data.projects) && data.projects[0]) ||
    data.project ||
    data.project_details ||
    {};

  const projectCategories =
    firstProject.project_categories ||
    firstProject.project_skills ||
    splitList(firstProject.required_skills);

  const projectDurationText =
    firstProject.project_duration && firstProject.duration_type
      ? `${firstProject.project_duration} ${firstProject.duration_type}`
      : data.project_duration || "";

  const talentSource = data.talent_types || splitList(data.hiring_needs);
  const communicationSource =
    data.communication_tools || splitList(data.communication_tools_used);

  const normalizedTalent = getKnownAndOther(
    splitList(talentSource),
    TALENT_TYPE_OPTIONS,
    data.talent_other || ""
  );
  const normalizedCommunication = getKnownAndOther(
    splitList(communicationSource),
    COMMUNICATION_TOOL_OPTIONS,
    data.communication_other || ""
  );

  return {
    ...data,
    company_description: data.company_description || data.company_bio || "",
    company_size: data.company_size || data.number_of_employees || "",
    linkedin_company: data.linkedin_company || data.linkedin_company_page || "",
    primary_contact_name:
      data.primary_contact_name || data.primary_contact_full_name || "",
    primary_contact_title:
      data.primary_contact_title || data.primary_contact_job_title || "",
    primary_contact_email:
      data.primary_contact_email || data.primary_contact_work_email || "",
    primary_contact_phone:
      data.primary_contact_phone || data.primary_contact_phone_number || "",
    secondary_contact_name:
      data.secondary_contact_name || data.secondary_contact_full_name || "",
    secondary_contact_title:
      data.secondary_contact_title || data.secondary_contact_job_title || "",
    secondary_contact_email:
      data.secondary_contact_email || data.secondary_contact_work_email || "",
    secondary_contact_phone:
      data.secondary_contact_phone || data.secondary_contact_phone_number || "",
    talent_types: normalizedTalent.selected,
    talent_other: normalizedTalent.other,
    engagement_types: data.engagement_types || splitList(data.engagement_type),
    communication_tools: normalizedCommunication.selected,
    communication_other: normalizedCommunication.other,
    collaboration_type:
      data.collaboration_type || data.types_of_collaboration || "",
    work_environment:
      data.work_environment || data.work_enviroment || "",
    consent_accuracy:
      data.consent_accuracy ?? data.information_confirmed ?? false,
    consent_contact:
      data.consent_contact ?? data.agree_contact_opportunities ?? false,
    project_title: data.project_title || firstProject.project_title || "",
    role_in_project: data.role_in_project || firstProject.role_in_project || "",
    required_skills:
      data.required_skills || (projectCategories || []).join(", "),
    project_description:
      data.project_description || firstProject.project_description || "",
    project_start_date:
      data.project_start_date || firstProject.start_date || "",
    project_duration: projectDurationText,
    estimated_budget:
      data.estimated_budget ||
      firstProject.budget ||
      data.project_budget ||
      "",
  };
};
